import type { CommandOf, CommandResult } from '@/core/app/commands';
import type { GameSave } from '@/core/persistence/schema/v1';
import { claimAchievement } from './achievements';
import type { HandlerEnv } from './placement/handlers';
import { claimTask, swapTask } from './suggestions';

/** claimReward: achievements and suggestions are claimed by the player, never automatically (except tutorial). */
export function claimReward(draft: GameSave, cmd: CommandOf<'claimReward'>, env: HandlerEnv): CommandResult {
  const r =
    cmd.source.kind === 'achievement'
      ? claimAchievement(draft, env.content, cmd.source.achievementId)
      : claimTask(draft, env.content, cmd.source.taskId, cmd.source.instanceKey);
  return r.ok ? { ok: true, events: r.events } : { ok: false, error: r.error };
}

export function swapSuggestion(
  draft: GameSave,
  cmd: CommandOf<'swapSuggestion'>,
  env: HandlerEnv,
): CommandResult {
  const r = swapTask(draft, env.content, cmd.taskId, cmd.instanceKey);
  return r.ok ? { ok: true, events: r.events } : { ok: false, error: r.error };
}

/** Reading (or skipping) a chapter. Reading is never required for rewards (story-dialogue §1). */
export function markChapterSeen(draft: GameSave, cmd: CommandOf<'markChapterSeen'>): CommandResult {
  if (!draft.story.unlockedChapters.includes(cmd.chapterId)) return { ok: false, error: 'LOCKED' };
  const firstTime = !draft.story.seenChapters.includes(cmd.chapterId);
  if (firstTime) draft.story.seenChapters.push(cmd.chapterId);
  return { ok: true, events: [{ type: 'CHAPTER_SEEN', chapterId: cmd.chapterId, firstTime }] };
}
